import { DialogContent, styled } from '@mui/material'

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: 0,
}))
